import {
  PaymentFrequency,
  PaymentPlanStatus,
} from '@principle-theorem/principle-core/interfaces';
import {
  ISerialisedDocumentReference,
  ISerialisedTimestamp,
} from '@principle-theorem/shared';
import {
  IBigQueryFirestoreModel,
  IBigQueryReffable,
  IBigQueryStatusHistory,
  ITimestampedDimension,
} from './common';

export interface IPaymentPlanDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    ITimestampedDimension {
  name: string;
  durationLength: number;
  durationType: string;
  invoices: ISerialisedDocumentReference[];
  treatmentPlan?: ISerialisedDocumentReference;
  status: PaymentPlanStatus;
  statusHistory: IBigQueryStatusHistory<PaymentPlanStatus>[];
  paymentFrequency: PaymentFrequency;
  paymentSchedule: IPaymentSchedule[];
  total: number;
  completedAt?: ISerialisedTimestamp;
}

interface IPaymentSchedule {
  amount: number;
  date: ISerialisedTimestamp;
}
